@if (isSmallScreen$) {
  <table class="w-100">
    <th class="py-3 w-100">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="p-2 nav-btn" (click)="changeWeek(-1)">
          <img src="assets/icons/chevron-left.svg" alt="Prev week" />
        </div>
        <span>Week</span>
        <div class="p-2 nav-btn" (click)="changeWeek(1)">
          <img src="assets/icons/chevron-right.svg" alt="Next week" />
        </div>
      </div>
    </th>
  </table>
}
@if (!isSmallScreen$) {
  <table class="table table-borderless w-100">
    <thead class="hide-on-sm">
      <tr>
        <th class="hide-on-sm py-4 px-2">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="p-2 nav-btn" (click)="changeWeek(-1)">
              <img src="assets/icons/chevron-left.svg" alt="Prev week" />
            </div>
            <span>Week</span>
            <div class="p-2 nav-btn" (click)="changeWeek(1)">
              <img src="assets/icons/chevron-right.svg" alt="Next week" />
            </div>
          </div>
        </th>
        @for (day of week; track day) {
          <th class="status-col pb-4">
            <div class="pb-2">
              {{ day.format("ddd") | lowercase | transloco }}
              {{ day.format("DD.MM") }}
            </div>
          </th>
        }
      </tr>
    </thead>
    @if (data) {
      <tbody>
        @for (status of data; track status) {
          <tr class="hide-on-sm">
            <td class="p-2 user-col col-2">
              <div class="text-break username">
                {{ status.userName }}
              </div>
            </td>
            @for (day of status.statDayRecords; track day) {
              <td
                class="status-col p-md-1"
                [class.filled]="day"
        [class.cursor-pointer]="
          (isUserAdmin$ || currentUserId === status.userId) && day != null
        "
                (click)="day ? redirect(status.userId, day.id) : false"
                >
                @if (day) {
                  <div class="p-sm-1 ps-sm-2">
                    <p class="lh-2 mb-0">{{ day.status | transloco }}</p>
                    @if (day.startTime) {
                      <p class="lh-2">
                        {{ "from" | transloco }} {{ day.startTime | date : "HH:mm" }}
                        {{ "to" | transloco }}
                        {{ day.endTime | date : "HH:mm" }}
                      </p>
                    }
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    } @else {
      <div class="w-100 d-flex justify-content-center p-4">
        <div class="spinner-border"></div>
      </div>
    }
  </table>
}
@if (isSmallScreen$) {
  <table class="table table-borderless w-100">
    @if (data) {
      <tbody>
        @for (day of week; track day; let i = $index) {
          <tr>
            <td class="p-0">
              <p
                class="w-100 m-0 p-2 justify-content-center align-items-center date-mobile"
                >
                {{ day.toDate() | date : "E" | lowercase | transloco }}
                {{ day.toDate() | date : "dd.MM" }}
              </p>
              @if (todayStatusesEmpty$[i]) {
                <p class="empty-label text-muted ps-2">
                  {{ "noStatuses" | transloco }}
                </p>
              }
              @for (status of data; track status) {
                <div
          [class.cursor-pointer]="
            (isUserAdmin$ || currentUserId === status.userId) &&
            status.statDayRecords[i]
          "
          (click)="
            status.statDayRecords[i]
              ? redirect(status.userId, status.statDayRecords[i].id)
              : false
          "
                  >
                  @if (status.statDayRecords[i]) {
                    <div
                      class="d-flex p-2 flex-column"
                      [class.filled]="status.statDayRecords[i].status"
                      >
                      <p class="w-100 me-2 username username-mobile">
                        {{ status.userName }}
                      </p>
                      <div class="w-100 d-flex pt-1">
                        <p class="text-start w-50">
                          {{ status.statDayRecords[i].status | transloco }}
                        </p>
                        @if (status.statDayRecords[i].startTime) {
                          <p
                            class="text-end w-50"
                            >
                            {{ "from" | transloco }}
                            {{ status.statDayRecords[i].startTime | date : "HH:mm" }}
                            {{ "to" | transloco }}
                            {{ status.statDayRecords[i].endTime | date : "HH:mm" }}
                          </p>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    } @else {
      <div class="w-100 d-flex justify-content-center p-4">
        <div class="spinner-border"></div>
      </div>
    }
  </table>
}
